import { userAdapter } from '@services/userAdapter';

type AdapterResponse = ReturnType<typeof userAdapter['getCurrentUser']>;
type Customer = AdapterResponse['currentUser'];
type SelectorFn = (data: Customer) => any;
type DefaultReturnType<T> = T extends SelectorFn ? ReturnType<T> : Customer;

const useCurrentUser = (
  selector?: SelectorFn,
): AdapterResponse & { currentUser: DefaultReturnType<SelectorFn> } => {
  const { currentUser, error, loading } = userAdapter.getCurrentUser();

  return {
    currentUser: selector && currentUser ? selector(currentUser) : currentUser,
    loading,
    error,
  };
};

export { useCurrentUser };
